/**
 * News Block Component
 * Displays a grid of articles on the home page
 * Uses GraphQL data from getAllArticles (passed as props from Server Component)
 * Uses ArticleCard from @uicwebmaster/articles package
 */

'use client';

import type { ArticleTeaser } from '@uicwebmaster/articles';
import { ArticleCard, ArticlesComponentsProvider } from '@uicwebmaster/articles';
import Image from 'next/image';
import Link from 'next/link';
import { BlockLayout } from './BlockLayout';

interface NewsProps {
  /** Articles data */
  articles: ArticleTeaser[];
}

export default function News({ articles }: NewsProps) {
  return (
    <ArticlesComponentsProvider
      config={{
        LinkComponent: Link,
        ImageComponent: Image,
        baseUrl: '/news/articles',
      }}
    >
      <BlockLayout
        title="News"
        seeAllUrl="/news"
        data={articles}
        renderItem={article => (
          <ArticleCard article={article} baseUrl="/news/articles" clickable={true} />
        )}
        loading={false}
        error={null}
      />
    </ArticlesComponentsProvider>
  );
}
